export enum ActionTypes {
    showcase = 'showcase',
    longread = 'longread',
    connect = 'connect',
    link = 'link'
}export enum ActionTypes {
    showcase = 'showcase',
    longread = 'longread',
    connect = 'connect',
    link = 'link'
}